import React, { useState, useRef, useEffect } from "react";
import { FaCirclePlay, FaCirclePause } from "react-icons/fa6";
import CustomButton from "../../CustomButton";
import { soundSources } from "./FleetConfigurationSounds";

export default function SoundPlayButton({ iconButton, soundKeyName, name, value }) {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const currentValueRef = useRef(null);
    const nameKey = soundKeyName || name;
    const settingSources = soundSources[nameKey];
    const noSettingSource = !settingSources || !value;

    useEffect(() => {
        if (currentValueRef.current && currentValueRef.current !== value) {
            audioRef.current?.pause();
            audioRef.current = null;
            currentValueRef.current = null;
            setIsPlaying(false);
        }
    }, [value]);

    const play = () => {
        if (noSettingSource) return;

        const src = settingSources[value];
        if (currentValueRef.current !== value) {
            audioRef.current?.pause();
            audioRef.current = new Audio(src);
            currentValueRef.current = value;
        }

        audioRef.current.play();
        setIsPlaying(true);

        audioRef.current.onended = () => setIsPlaying(false);
    };

    const pause = () => {
        audioRef.current?.pause();
        setIsPlaying(false);
    };

    const handleClick = () => {
        if (isPlaying) {
            pause();
        } else {
            play();
        }
    };

    return (
        <CustomButton
            prefix={`play-btn ${isPlaying ? 'is-playing' : ''} ${noSettingSource ? 'disabled' : ''}`}
            variant={iconButton ? "tertiary" : "toggle-group"}
            {...(iconButton && {
                size: "icon"
            })}
            onClick={handleClick}
        >
            {isPlaying ? (
                <FaCirclePause color="#ED1E79" />
            ) : (
                <FaCirclePlay color={noSettingSource ? "#C2C2C2" : "#0071b6"} />
            )}
        </CustomButton>
    );
}
